import * as React from 'react'
import ReactPlayer from 'react-player'
import dynamic from 'next/dynamic'
import { useTranslation } from 'i18n'

const PDFCarousel = dynamic(() => import('./PDFCarousel'))
const SoundPlayer = dynamic(() => import('./SoundPlayer'))

const Component = ({
  type,
  resource,
  width,
  pdfControlStyle,
}: {
  type: string
  resource: any
  width: number
  pdfControlWidth?: number
  pdfControlStyle?: React.CSSProperties
}) => {
  const { t } = useTranslation('components')

  if (type === 'video')
    return (
      <div style={{ padding: '30px 0', textAlign: 'center' }}>
        <ReactPlayer
          width="100%"
          height="auto"
          url={resource.uri}
          controls
          config={{
            file: {
              attributes: {
                controlsList: 'nodownload',
                onContextMenu: e => e.preventDefault(),
              },
            },
          }}
        />
      </div>
    )

  if (type === 'audio') return <SoundPlayer uri={resource.uri} />

  if (type === 'magazine')
    return (
      <PDFCarousel
        uri={resource.uri}
        width={width}
        controlStyle={pdfControlStyle}
      />
    )

  return <p>{t('ResourcePlayer.unableReadMediaFormat')}</p>
}

export default Component
